<template>
  <form @submit.prevent>
    <div>
      <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted" @activate-tab="clearFormIfLibraryViewActive">
        <b-tab :active="showLibraryItems">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
          </template>

          <LibraryItems
            rightPanelId="sidebar-add-risk"
            organizationScopedState="organizationRisk"
            :hideSaveAs="true"
            libraryScopedState="riskDefinition"
            :query="{ products: { value: { $in: [currentProduct] }, isObject: true } }"
            :navigateInsteadAddFromLibrary="handleSelectedRiskDefinition"
            :shouldAdaptSaveAsButtonTextToScopeAndCurrentAccount="true"
            @interceptForSetParent="interceptForSetParent"
          />
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("risk.new") }}</span>
          </template>

          <OrganizationRiskDetail @onSave="close" :hideGoBack="true" />
        </b-tab>
      </b-tabs>

      <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
        {{ $t("common.cancel") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import LibraryItems from "@cc/library-items";
import OrganizationRiskDetail from "./organization-risk-detail.vue";

import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  props: ["hide-library", "product"],
  components: {
    LibraryItems,
    OrganizationRiskDetail,
  },
  data() {
    return {
      form: { name: undefined },
      formError: undefined,
      entityName: undefined,
      libraryItem: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  watch: {},
  computed: {
    query() {
      const products = [this.currentProduct || "PLATFORM"];

      return { products };
    },

    copingEntity() {
      return this.$store.getters["organizationRisk/copingEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationRisk/isEditMode"];
    },
    showLibraryItems() {
      return !this.hideLibrary && !this.isEditMode && !this.isCoping;
    },
    isCoping() {
      return this.$store.getters["organizationRisk/isCoping"];
    },
  },
  mounted() {},
  methods: {
    interceptForSetParent(item) {
      item.status = "RATING";
      item.originalId = item._id;
      item._id = undefined;
      item.libraryItem = item._id;

      this.$store.commit("organizationRisk/risk", item);
    },
    close() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-add-new-risk");
    },
    clearFormIfLibraryViewActive(e) {
      if (e == 0) {
        this.$store.commit("organizationRisk/reset");
        this.$store.commit("organizationRisk/copingEntity", undefined);
      }
    },
    customLabel(value) {
      return this.$options.filters.translate(value.name);
    },

    async handleSelectedRiskDefinition(libraryRiskDefinition) {
      const threatDefinition = libraryRiskDefinition.threats.reduce((acc, threat) => {
        for (const [lang, value] of Object.entries(threat.name)) {
          acc[lang] = acc[lang] ? acc[lang] + ", " + value : value;
        }
        return acc;
      }, {});

      const weaknessDefinition = libraryRiskDefinition.weaknesses.reduce((acc, weakness) => {
        for (const [lang, value] of Object.entries(weakness.name)) {
          acc[lang] = acc[lang] ? acc[lang] + ", " + value : value;
        }
        return acc;
      }, {});

      const risk = {
        navigatedByAddFromLibrary: true,
        category: libraryRiskDefinition.category,
        name: libraryRiskDefinition.name,
        threats: libraryRiskDefinition.threats,
        weaknesses: libraryRiskDefinition.weaknesses,
        libraryItem: libraryRiskDefinition,
        products: [this.currentProduct],
      };

      this.$store.commit("organizationRisk/risk", risk);
      this.$store.commit("organizationRisk/copingEntity", risk);
    },
    cancel() {
      this.$store.dispatch("organizationRisk/resetForm");
      this.$root.$emit("bv::toggle::collapse", "sidebar-add-new-risk");
    },
  },
};
</script>
